export function updateWithSubstitute({data,
                                         conflicts,
                                         setResolvedConflicts,
                                         setSubstituteTableData,
                                         setSubstitutesSelected,
                                         selectedType,
                                         setDataByDay,
                                         setDataByEffective}){

    conflicts.forEach(conflict => {
        const solvedConflict = {
            conflictId: conflict,
            substituteId: parseInt(data.id),
            isIgnoreSubstitute: false
        }

        setResolvedConflicts((prevItems) => {
            const exists = prevItems.some(item => item.conflictId === solvedConflict.conflictId);

            if (exists) {
                return prevItems.map(item => item.conflictId === solvedConflict.conflictId ? { ...item, ...conflict } : item);
            }

            return [...prevItems, solvedConflict];
        });

        setSubstituteTableData(prevItems => {
            return prevItems.map(item => {
                if (item.id === solvedConflict.conflictId) {
                    item.substitute_id = parseInt(data.id);
                    item.substitute = data.name;
                    return item
                }

                return item;
            })
        });
    })
    updateOriginData({data, conflicts, selectedType, setDataByDay, setDataByEffective, setSubstitutesSelected});
}

export function handleWithoutSubstitute({conflicts,
                                            setResolvedConflicts,
                                            setSubstituteTableData,
                                            setSubstitutesSelected,
                                            selectedType,
                                            setDataByDay,
                                            setDataByEffective}) {
    conflicts.forEach(conflict => {
        const conflictSolved = {
            conflictId: conflict,
            substituteId: null,
            isIgnoreSubstitute: true
        }

        setResolvedConflicts((prevItems) => {
            const exists = prevItems.some(item => item.conflictId === conflictSolved.conflictId);

            if (exists) {
                return prevItems.map(item => item.conflictId === conflictSolved.conflictId ? { ...item, ...conflictSolved } : item);
            }

            return [...prevItems, conflictSolved];
        });

        setSubstituteTableData(prevItems => {
            return prevItems.map(item => {
                if (item.id === conflictSolved.conflictId) {
                    item.substitute_id = null;
                    item.substitute = "Sem substituto";
                    return item
                }

                return item;
            })
        });
    })

    updateOriginData({data:null, conflicts, selectedType, setDataByDay, setDataByEffective, setSubstitutesSelected})
}

const updateOriginData = ({data, conflicts, selectedType, setDataByDay, setDataByEffective, setSubstitutesSelected}) => {
    setSubstitutesSelected([]);
    const updateConflicts = (items, id) => {
        if(data) {
            return items.map(el => ({
                ...el,
                conflicts: el.conflicts.map(item =>
                    item.id === id
                        ? { ...item, substitute_id: parseInt(data.id), substitute: data.name }
                        : item
                )
            }));
        } else {
            return items.map(el => ({
                ...el,
                conflicts: el.conflicts.map(item =>
                    item.id === id
                        ? { ...item, substitute_id: null, substitute: "Sem substituto" }
                        : item
                )
            }));
        }
    };

    conflicts.forEach(conflict => {
        if (selectedType === 'effective') {
            setDataByDay(prevItems => updateConflicts(prevItems, conflict));
        }

        if (selectedType === 'day') {
            setDataByEffective(prevItems => updateConflicts(prevItems, conflict));
        }
    })
};

export function groupConflicts(conflicts) {
    const map = new Map();

    conflicts.forEach(conflict => {
        const key = `${conflict.effectiveId}_${conflict.startDate}_${conflict.endDate}`;

        if (!map.has(key)) {
            map.set(key, {
                ...conflict,
                observation: [conflict.observation], // vira array
                substitute: ""
            });
        } else {
            const existing = map.get(key);
            existing.observation.push(conflict.observation);
        }
    });

    return Array.from(map.values()).map(item => ({
        ...item,
        observation: item.observation.join(", ")
    }));
}